var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewtime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.042,
    height: 59.042,
    viewBox: "0 0 59.042 59.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_17616978291577437017",
    "data-name": 17616978291577436000,
    d: "M31.521,2A29.521,29.521,0,1,0,61.042,31.521,29.608,29.608,0,0,0,31.521,2Zm14.76,31.629H31.521a1.992,1.992,0,0,1-2.109-2.109V12.543a2.109,2.109,0,1,1,4.217,0V29.412H46.281a2.109,2.109,0,1,1,0,4.217Z",
    transform: "translate(-2 -2)",
    fill: "#16b1ef"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewtime);
export default __webpack_public_path__ + "static/media/reviewtime.a0f495a46dbed6908319b1542853b209.svg";
export { ForwardRef as ReactComponent };